<template>
    <app-page>
	    <empty-state
		    icon="group_work"
		    title="No groups found"
		    description="To start using dashboards, create or join a group from your PioneerRx software"
	    />
    </app-page>
</template>


<script>

	export default {
		name: 'no-groups-found',
		data() {
            return {};
		}
	};
</script>
